import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface AppState {
  isDrawerOpen: boolean;
  isDrawerVisible: boolean;
  isMitIdLoginEnabled: boolean;
  isHeaderAuthMenuVisible: boolean;
}

const initialState: AppState = {
  isDrawerOpen: true,
  isDrawerVisible: true,
  isMitIdLoginEnabled: true,
  isHeaderAuthMenuVisible: true,
};

const appSlice = createSlice({
  name: "app",
  initialState,
  reducers: {
    setDrawerOpen(state, action: PayloadAction<AppState["isDrawerOpen"]>) {
      state.isDrawerOpen = action.payload;
    },
    setDrawerVisible(state, action: PayloadAction<AppState["isDrawerVisible"]>) {
      state.isDrawerVisible = action.payload;
    },
    setMitIdLoginEnabled(state, action: PayloadAction<AppState["isMitIdLoginEnabled"]>) {
      state.isMitIdLoginEnabled = action.payload;
    },
    setHeaderAuthMenuVisible(state, action: PayloadAction<AppState["isHeaderAuthMenuVisible"]>) {
      state.isHeaderAuthMenuVisible = action.payload;
    },
  },
});

export const { setDrawerOpen, setDrawerVisible, setMitIdLoginEnabled, setHeaderAuthMenuVisible } = appSlice.actions;
export type { AppState };
export default appSlice.reducer;
